<template>
  <div class="size-10 flex justify-center items-center">
    <div class="size-full border-blue-500 border-t-slate-500 border-[4px] rounded-full animate-spin duration-100" />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>